module.exports = __webpack_public_path__ + "img/provider-gemini.f244a29c.png";